import React from "react";
import { postData } from "../../../../api/componentAPIs";
import MESSAGES from "../../../../appMessages";
import "./../style.scss";
import { withStyles } from "@material-ui/core/styles";
import {
  Table,
  TableBody,
  TableCell,
  TableRow,
  Paper,
} from "@material-ui/core";
import styles from "../MapPopupStyles.js";
import { getCombinedIconsArray } from "../PopupUtil";
import {trackEvent} from "../../../common/AppInsightsEventTracking";
import { getStopCustomerInfo } from "../../../modules/IBPlanning/Common/MergeStops/utills";
import Header from "./components/Header";
import Footer from "./components/Footer";
import Content from "./components/Content";
import { getPopupContent } from "./utils";

class StopPopupInfo extends React.Component {
  constructor(props) {
    super(props);
    this._unMounted= false;
    this.state ={
      nearbyRoutes: "",
      isLastStopInProgress: false,
      isfindNearByRoutesInProgress: false,
      isFirstStopInProgress:false
    }
    this.routeName = this.props.data.routeName;
  }

  componentDidUpdate(prevProps){
    if (this.props.data !== prevProps.data && !this._unMounted) {
      this.setState({
        nearbyRoutes: ""
      });
    }
  }
componentWillUnmount(){
  this._unMounted = true;
}
  findNearbyRoutes = () => {
    const { data, scenarioID, userProfile } = this.props;
    this.setState({
      isfindNearByRoutesInProgress: true
	  })
	
	this.props.glEventHub.emit("UpdateIBStore", "setdisableStoreUpdate", [true]);
    postData("GetNearbyRoutes", {
      scenarioId: scenarioID,
      routeName: data.routeName,
      sequence: data.stopSequence,
      customerId: data.consigneeId
    }).then(response => {
      if(!this._unMounted){
        if (response && response.status === 200) {
          if(response.data.length > 0){
             this.setState({
              isfindNearByRoutesInProgress: false
            });
            this.props.selectedRoutes([...response.data.map(routeName => String(routeName)), data.routeName]);
          } else {
            this.setState({
              nearbyRoutes: MESSAGES.FIND_NEARBY_ROUTES.NO_ROUTES,
              isfindNearByRoutesInProgress: false
            });
          }
        } else {
          this.setState({
            nearbyRoutes: MESSAGES.FIND_NEARBY_ROUTES.FETCH_DATA_FAILURE,
            isfindNearByRoutesInProgress: false
          });
        }
	  }
	  this.props.glEventHub.emit("UpdateIBStore", "setdisableStoreUpdate", [false]);
      }, error =>{
        if(!this._unMounted){
			this.setState({
			nearbyRoutes: MESSAGES.FIND_NEARBY_ROUTES.FETCH_DATA_FAILURE,
			isfindNearByRoutesInProgress: false
			});
	  	}
	  	this.props.glEventHub.emit("UpdateIBStore", "setdisableStoreUpdate", [false]);
      });

      trackEvent("NearbyRoutes", userProfile, {route:this.routeName});
}

  onMarkAsLastStop = () => {
    const { data, userProfile } = this.props;
    const successMessage = !data.isLastStop ? MESSAGES.LAST_STOP.MARK_SUCCESS : MESSAGES.LAST_STOP.UNMARK_SUCCESS ;
    const failureMessage = !data.isLastStop ? MESSAGES.LAST_STOP.MARK_FAILURE : MESSAGES.LAST_STOP.UNMARK_FAILURE ;
    this.setState({
      isLastStopInProgress: true
	})
	this.props.glEventHub.emit("UpdateIBStore", "setdisableStoreUpdate", [true]);
    postData("UpdateLastStop", {
      isLastStop: !data.isLastStop,
      scenarioId: this.props.scenarioID,
	  routeId: data.routeId,
	  routeName: data.routeName,
	  sequence: data.stopSequence,
	  customerId: data.consigneeId
    }).then(
      response => {
          if (Math.trunc(response.status/100) === 2) {
            this.props.showNotification(successMessage,"success");
            this.props.refreshData();
          } else {
            this.props.showNotification(failureMessage, "error");
            if(response?.response?.status !== 409){
               this.props.glEventHub.emit("UpdateIBStore", "setdisableStoreUpdate", [false]);
            }  
          }
          if(!this._unMounted){
            this.setState({
              isLastStopInProgress: false
            });
          }
      },
      error => {
		this.props.showNotification(failureMessage, "error");
		this.props.glEventHub.emit("UpdateIBStore", "setdisableStoreUpdate", [false]);
        if(!this._unMounted){
          this.setState({
            isLastStopInProgress: false
          })
        }
      }
    );
    trackEvent("MarkAsLastStop", userProfile, {route:this.routeName});
  };

  onMarkAsFirstStop = () => {
    const { data, userProfile } = this.props;
    const successMessage = !data.isFirstStop ? MESSAGES.FIRST_STOP.MARK_SUCCESS : MESSAGES.FIRST_STOP.UNMARK_SUCCESS ;
    const failureMessage = !data.isFirstStop ? MESSAGES.FIRST_STOP.MARK_FAILURE : MESSAGES.FIRST_STOP.UNMARK_FAILURE ;
    this.setState({
      isFirstStopInProgress: true
	})
	this.props.glEventHub.emit("UpdateIBStore", "setdisableStoreUpdate", [true]);
    postData("UpdateFirstStop", {
      isFirstStop: !data.isFirstStop,
      scenarioId: this.props.scenarioID,
	  routeId: data.routeId,
	  routeName: data.routeName,
	  sequence: data.stopSequence,
	  customerId: data.consigneeId
    }).then(
      response => {
        if (Math.trunc(response.status/100) === 2) {
          this.props.showNotification(successMessage,"success");
          this.props.refreshData();
        }
        else {
          this.props.showNotification(failureMessage, "error");
          if(response?.response?.status !== 409){
             this.props.glEventHub.emit("UpdateIBStore", "setdisableStoreUpdate", [false]);
          }         
        }
        if(!this._unMounted){
          this.setState({
            isFirstStopInProgress: false
          });
        }
      },
      error => {
		this.props.showNotification(failureMessage, "error");
		this.props.glEventHub.emit("UpdateIBStore", "setdisableStoreUpdate", [false]);
        if(!this._unMounted){
          this.setState({
            isFirstStopInProgress: false
          })
        }
      }
    );
    trackEvent("MarkAsFirstStop", userProfile, {route:this.routeName});
  };

  render() {
    const infoData = this.props.data;
    const { classes, theme, showDateRangeInShipmentSelection } = this.props;
    const {name, address} = getStopCustomerInfo(infoData)
    const combinedIconsArray = getCombinedIconsArray(infoData, this.props.specialNeedsOptions);    
    const params = {
      data:{
        priority:infoData.priority,
        apt: infoData.apt
      },
      value:infoData.deliveryWindow
    }
    const contentData = getPopupContent({showDateRangeInShipmentSelection, params, infoData});
    return (
      <Paper className="popupBGColor">
        <Table className={classes.table} padding="none">
          <Header
            theme={theme}
            name={name}
            address={address}
            infoData={infoData}
            combinedIconsArray={combinedIconsArray}
          />
          <TableBody>
            <Content contentData={contentData} theme={theme}/>
            <TableRow className={classes.tableRowRoot}>
              <TableCell colSpan={2} className={classes.labelCell}>
                <div className={classes.nearbyRoutesStyle}>
                  {this.state.isfindNearByRoutesInProgress ? (
                    <div>Finding routes...</div>
                  ) : this.state.nearbyRoutes ? (
                    <div>{this.state.nearbyRoutes}</div>
                  ) : (
                    <div
                      onClick={this.findNearbyRoutes}
                      className={classes.nearbyRoutesLabel}
                    >
                      Find Nearby Routes
                    </div>
                  )}
                </div>
              </TableCell>
            </TableRow>
          </TableBody>
          <Footer
            infoData={infoData}
            onMarkAsFirstStop={this.onMarkAsFirstStop}
            onMarkAsLastStop={this.onMarkAsLastStop}
            isFirstStopInProgress={this.state.isFirstStopInProgress}
            isLastStopInProgress={this.state.isLastStopInProgress}
          />
        </Table>
      </Paper>
    );
  }
}

export default withStyles(styles)(StopPopupInfo);
